<template>
  <div class="bor-cor" :class="{ 'no-arrow': !arrow }">
    <div class="trigger" :class="{ 'always-display': alwaysDisplay }">
      <slot name="trigger"></slot>
    </div>
    <div v-if="!disabled" class="menu-container" :class="[type, { reverse: reverse }]" :style="{ '--sd-style': shadow }">
      <div class="menu-block default-shadow" :style="menuBlockStyle">
        <slot name="content"></slot>
      </div>
      <span class="cursor-bor-cor"></span>
      <template v-if="arrow">
        <span class="menu-bor-cor shadow-top" :style="{ '--bd-color': border }"></span>
        <span class="menu-bor-cor shadow-left" :style="{ '--bd-color': border }"></span>
        <span class="menu-bor-cor shadow-right" :style="{ '--bd-color': border }"></span>
        <span class="menu-bor-cor" :style="{ '--bg-color': background }"></span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: () => 'bottom'
    },
    reverse: {
      type: Boolean,
      default: () => false
    },
    arrow: {
      type: Boolean,
      default: () => true
    },
    alwaysDisplay: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    // style
    width: {
      type: String,
      default: () => ''
    },
    background: {
      type: String,
      default: () => '#f3f3f3'
    },
    border: {
      type: String,
      default: () => '#aaaaaa'
    },
    radius: {
      type: String,
      default: () => '3px'
    },
    shadow: {
      type: String,
      default: () => '0px 0px 0px transparent'
    },
    blockStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    menuBlockStyle () {
      let style = {
        width: this.width || 'auto',
        'white-space': this.width ? 'pre-line' : 'nowrap',
        '--bg-color': this.background,
        '--bd-color': this.border,
        '--br-value': this.radius
      }
      return { ...style, ...this.blockStyle }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
.bor-cor
  position: relative
  &.no-arrow
    .trigger
      &:hover, &.always-display
        & + .menu-container
          &.bottom
            top: calc(100% + 5px)
          &.top
            bottom: calc(100% + 5px)
          &.right
            left: calc(100% + 5px)
          &.left
            right: calc(100% + 5px)
    .menu-container
      &.bottom
        &:hover
          top: calc(100% + 5px)
      &.top
        &:hover
          bottom: calc(100% + 5px)
      &.right
        &:hover
          left: calc(100% + 5px)
      &.left
        &:hover
          right: calc(100% + 5px)
  .trigger
    & > div
      display: flex
    &:hover, &.always-display
      & + .menu-container
        opacity: 1
        &.bottom
          top: calc(100% + 15px)
        &.top
          bottom: calc(100% + 15px)
        &.right
          left: calc(100% + 15px)
        &.left
          right: calc(100% + 15px)
  .menu-container
    opacity: 1
    position: absolute
    opacity: 0
    transition: opacity .5s ease
    z-index: 10
    filter: drop-shadow(var(--sd-style))
    &:hover
      opacity: 1
    &.bottom
      left: calc(50% - 20px)
      top: -99999px
      &:hover
        top: calc(100% + 15px)
      .cursor-bor-cor
        top: -50px
        left: 0
      .menu-bor-cor
        top: -19px
        left: 15px
        border-width: 10px 5px
        border-color: transparent transparent var(--bg-color)
        &.shadow-top
          top: -21px
          border-color: transparent transparent var(--bd-color)
        &.shadow-left
          left: 16px
          border-color: transparent transparent var(--bd-color)
        &.shadow-right
          left: 14px
          border-color: transparent transparent var(--bd-color)
      &.reverse
        left: inherit
        right: calc(50% - 20px)
        .cursor-bor-cor
          left: inherit
          right: 0
        .menu-bor-cor
          left: inherit
          right: 15px
          &.shadow-top
            top: -21px
          &.shadow-left
            left: inherit
            right: 16px
          &.shadow-right
            left: inherit
            right: 14px
    &.top
      left: calc(50% - 20px)
      bottom: 99999px
      &:hover
        bottom: calc(100% + 15px)
      .cursor-bor-cor
        bottom: -50px
        left: 0
      .menu-bor-cor
        bottom: -19px
        left: 15px
        border-width: 10px 5px
        border-color: var(--bg-color) transparent transparent
        &.shadow-top
          bottom: -21px
          border-color: var(--bd-color) transparent transparent
        &.shadow-left
          left: 16px
          border-color: var(--bd-color) transparent transparent
        &.shadow-right
          left: 14px
          border-color: var(--bd-color) transparent transparent
      &.reverse
        left: inherit
        right: calc(50% - 20px)
        .cursor-bor-cor
          left: inherit
          right: 0
        .menu-bor-cor
          left: inherit
          right: 15px
          &.shadow-top
          &.shadow-left
            left: inherit
            right: 16px
          &.shadow-right
            left: inherit
            right: 14px
    &.right
      top: calc(50% - 20px)
      left: -99999px
      &:hover
        left: calc(100% + 15px)
      .cursor-bor-cor
        left: -50px
        top: 0
      .menu-bor-cor
        left: -19px
        top: 15px
        border-width: 5px 10px
        border-color: transparent var(--bg-color) transparent transparent
        &.shadow-top
          left: -21px
          border-color: transparent var(--bd-color) transparent transparent
        &.shadow-left
          top: 16px
          border-color: transparent var(--bd-color) transparent transparent
        &.shadow-right
          top: 14px
          border-color: transparent var(--bd-color) transparent transparent
      &.reverse
        top: inherit
        bottom: calc(50% - 20px)
        .cursor-bor-cor
          top: inherit
          bottom: 0
        .menu-bor-cor
          top: inherit
          bottom: 15px
          &.shadow-top
          &.shadow-left
            top: inherit
            bottom: 16px
          &.shadow-right
            top: inherit
            bottom: 14px
    &.left
      top: calc(50% - 20px)
      right: -99999px
      &:hover
        right: calc(100% + 15px)
      .cursor-bor-cor
        right: -50px
        top: 0
      .menu-bor-cor
        right: -19px
        top: 15px
        border-width: 5px 10px
        border-color: transparent transparent transparent var(--bg-color)
        &.shadow-top
          right: -21px
          border-color: transparent transparent transparent var(--bd-color)
        &.shadow-left
          top: 16px
          border-color: transparent transparent transparent var(--bd-color)
        &.shadow-right
          top: 14px
          border-color: transparent transparent transparent var(--bd-color)
      &.reverse
        top: inherit
        bottom: calc(50% - 20px)
        .cursor-bor-cor
          top: inherit
          bottom: 0
        .menu-bor-cor
          top: inherit
          bottom: 15px
          &.shadow-top
          &.shadow-left
            top: inherit
            bottom: 16px
          &.shadow-right
            top: inherit
            bottom: 14px
    .cursor-bor-cor
      width: 50px
      height: 50px
      position: absolute
    .menu-bor-cor
      z-index: 10
      width: 0
      height: 0
      font-size: 0
      border-style: solid
      overflow: hidden
      position: absolute
    .menu-block
      padding: 10px
      color: #777777
      text-align: left
      line-height: 1.4
      background: var(--bg-color)
      box-sizing: border-box
      border-radius: var(--br-value)
      border: 1px solid var(--bd-color)
      word-break: break-word
      white-space: nowrap
      position: relative
      z-index: 10
</style>



// WEBPACK FOOTER //
// src/components/tool/borCor.vue